// extracted by mini-css-extract-plugin
module.exports = {"buttons":"DriverKillQuestions_buttons__12M9f","questionContainer":"DriverKillQuestions_questionContainer__SkOrF"};